import { render } from "./ModalDevolucao.vue?vue&type=template&id=3cd6c7d4&ts=true"
import script from "./ModalDevolucao.vue?vue&type=script&lang=ts"
export * from "./ModalDevolucao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__